export enum DataType {
  NETWORK = 'network',
  SOURCE = 'source',
}
